import moment from "moment";
import { poNumberFormate } from "jsFunctions/helperFunctions";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { poMonthFormate } from "jsFunctions/helperFunctions";

export const getExpenseExcelData = (expenseList) => {
    let list = JSON.parse(JSON.stringify(expenseList));
    const exportData = list.map((data, index) => {
      let content = {
        no: index + 1,
        "Order PO Number": data.poNo && poNumberFormate(data.poNo),
        "Current Order Date":
          data.oDt && moment(data.oDt).format("DD-MMM-YYYY"),
        "Current Order Month": data.om && poMonthFormate(data.om),

        "Major Type": data?.mjId?.val,
        "Minor Type": data?.mnId?.val,
        "Minor Sub Category": data?.msId?.val,
        "Client Name": data.clId?.clName,
        "Project Name": data.prId?.prj,
        "Resource Name": data?.mrId?.name || data?.resId?.name,
        "Remarks": data.rmks,
        
        "Requested Amount":`₹ ${data.pyInfo?.apAmt  ? formatAmountIndianRupees(data.pyInfo?.apAmt) : Number(0).toFixed(2)}`,
        "Approved Amount":`₹ ${data.pyInfo?.tlAmt  ? formatAmountIndianRupees(data.pyInfo?.tlAmt) : Number(0).toFixed(2)}`,
        
        "Is It Refund Amount?": data?.rfdInfo?.sts ? "true" : "false",
       
      

        "Reimbursement Applicable?": data?.rmbInfo?.isRmb?.sts ? "true" : "false",
        "Reimbursement Amount": `₹ ${data?.rmbInfo?.isRmb?.amt  ? formatAmountIndianRupees(data?.rmbInfo?.isRmb?.amt) : Number(0).toFixed(2)}`,
        "Reimbursement Source": data?.rmbInfo?.isRmb?.crId?.val,
        "Reimbursement Invoice Number": data?.rmbInfo?.inNo,
        "Reimbursement Invoice Date":
          data?.rmbInfo?.inDt &&
          moment(data?.rmbInfo?.inDt).format("DD-MMM-YYYY"),

        "TDS Applicable?": data?.tdsApl?.sts ? "true" : "false",
        "TDS Generated PO Number":
          data?.tdsApl?.tdsPo?.sts &&
          poNumberFormate(data?.tdsApl?.tdsPo?.poNo),
      };
      if (data?.pyInfo?.list?.length > 0) {
        data.pyInfo.list.forEach((element, index) => {
          content[`Payment ${index + 1} Spent Amount`] = `₹ ${element?.amt  ? formatAmountIndianRupees(element?.amt) : Number(0).toFixed(2)}`;
          content[`Payment ${index + 1} Bank`] = element?.bnkId?.val;
          content[`Payment ${index + 1} Payee`] = element?.pyId?.val;
          content[`Payment ${index + 1} Date`] = element?.pmtDt &&
            moment(element?.pmtDt).format("DD-MMM-YYYY");
  
        
        });
      }
     
      content["Space Added"] = "--------------";
    

      
      content["Created AT"] = data.crAt ? moment(data.crAt).format("DD-MMM-YYYY") : '';

      return content;
    });
    return exportData;
  };